import { Component, DestroyRef, inject, TemplateRef, ViewChild } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ToastComponent, ToastService } from '@ftr/foundation'
import { WindowRefService } from '@ftr/ui-core'
import { ActiveToast } from 'ngx-toastr'
import { DesktopApiService } from '../../../services'

@Component({
  selector: 'ftr-update-app-toast',
  templateUrl: './update-app-toast.component.html',
  standalone: false,
})
export class UpdateAppToastComponent {
  @ViewChild('updateMessage') updateMessage: TemplateRef<any>

  private currentToast: ActiveToast<ToastComponent> | undefined
  readonly #destroyRef = inject(DestroyRef)

  constructor(
    private readonly windowRefService: WindowRefService,
    private readonly desktopApiService: DesktopApiService,
    private readonly toastService: ToastService,
  ) {
    this.desktopApiService
      .getUpdateReadyAsObservable()
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(isMajorUpdate => {
        if (this.currentToast) {
          this.currentToast.toastRef.close()
        }

        this.currentToast = this.toastService.info(
          this.updateMessage,
          isMajorUpdate ? 'Major Update Available' : 'Update Available',
          {
            disableTimeOut: true,
            hideClose: isMajorUpdate,
          },
        )
      })
  }

  restartApp(toast: ToastComponent): void {
    this.currentToast = undefined
    this.windowRefService.getDesktopElectronApi()?.restartApp?.()
    toast.remove()
  }
}
